import { combineReducers } from 'redux';

const updateOneSchool = (state, schoolId, changes) => {
  return {
    ...state,
    items: {
      ...state.items,
      [schoolId]: {
        ...state.items[schoolId],
        ...changes,
      },
    },
  };
};

const updateSchoolCount = (state, action, type) => {
  if (!action.schoolId) return state;
  const school = state.items[action.schoolId];
  return updateOneSchool(state, action.schoolId, {
    counts: {
      ...school.counts,
      [type]: school.counts[type] + action.response.result.length,
    },
  });
};

const byId = (
  state = {
    isFetching: false,
    items: {},
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_ALL_SCHOOLS_REQUEST':
    case 'FETCH_SCHOOL_REQUEST':
      return {
        ...state,
        isFetching: true,
      };
    case 'FETCH_ALL_SCHOOLS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        items: {
          ...state.items,
          ...action.response.entities.schools,
        },
      };
    case 'FETCH_SCHOOL_SUCCESS':
      return updateOneSchool(
        { ...state, isFetching: false },
        action.schoolId,
        action.response.entities.schools[action.schoolId]
      );
    case 'FETCH_ALL_SCHOOLS_FAILURE':
    case 'FETCH_SCHOOL_FAILURE':
      return {
        ...state,
        isFetching: false,
      };
    case 'FETCH_SEAT_LIMITS_SUCCESS': {
      const seatLimitSchool = state.items[action.schoolId];
      const existingLimits = seatLimitSchool ? seatLimitSchool.limits : {};
      const existingCounts = seatLimitSchool ? seatLimitSchool.counts : {};
      return updateOneSchool(state, action.schoolId, {
        limits: {
          ...existingLimits,
          [action.userType]: action.response.results.limit,
        },
        counts: {
          ...existingCounts,
          [action.userType]: action.response.results.taken,
        },
      });
    }
    case 'FETCH_DISABLED_MODULES_SUCCESS': {
      return updateOneSchool(state, action.schoolId, {
        disabledModules: action.combinedResult.disabledModules,
        classDisabledModules: action.combinedResult.classDisabledModules,
      });
    }
    case 'ADD_USER_TO_USER_GROUP': {
      if (action.name === 'students_in_school') {
        return updateSchoolCount(state, action, 'students');
      }
      if (action.name === 'teachers_in_school') {
        return updateSchoolCount(state, action, 'teachers');
      }

      return state;
    }
    case 'POST_LOGOUT_SUCCESS':
      return {
        ...state,
        items: {},
      };
    default:
      return state;
  }
};

const licensesBySchool = (
  state = {
    isFetching: false,
    items: {},
  },
  action
) => {
  const { type, schoolId } = action;
  switch (type) {
    case 'FETCH_SCHOOL_LICENSE_REQUEST':
      return {
        ...state,
        isFetching: true,
      };
    case 'FETCH_SCHOOL_LICENSES_SUCCESS':
      return {
        ...state,
        isFetching: false,
        items: {
          ...state.items,
          [schoolId]: action.response.results,
        },
      };
    case 'FETCH_SCHOOL_LICENSES_FAILURE':
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};

const schools = combineReducers({
  byId,
  licensesBySchool,
});

export default schools;
export const getAllSchools = (state) => state.byId.items;
export const getSchool = (state, id) => (id ? state.byId.items[id] : null);
export const getSchoolSeatLimit = (state, id, type) => {
  const school = state.byId.items[id];
  if (!school || !school.limits || !school.limits[type]) return undefined;
  return school.limits[type];
};
export const getIsFetchingSchools = (state) => state.byId.isFetching;
export const getIsFetchingLicenses = (state) =>
  state.licensesBySchool.isFetching;
export const getLicensesForSchool = (state, id) =>
  state.licensesBySchool.items[id];
